// extracted by mini-css-extract-plugin
export default {"outView":"CaseDetailView_outView__jfq-p","imageView":"CaseDetailView_imageView__GoQf-","textView":"CaseDetailView_textView__edKdh"};